// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"LogoBanner_headerContainer__EdA_I","headerImage":"LogoBanner_headerImage___tRUE"};